import React from 'react'

import { Colors } from '../../design/Colors';
import { Fonts } from '../../design/Font';

//Chevrons
import u370 from '../../images/accounts/u370.png' // left chevron
import u373 from '../../images/accounts/u373.png' // right chevron



export default class PageNavigator extends React.Component{

    constructor(props){
        super(props);
        this.parentRef = React.createRef();
        this.state={
            
        }
    }
    

    render(){
        const {index,length,navLeft,navRight} = this.props
        return <div style={{display:'flex', alignItems:'center', justifyContent:'center'}}>
            <div onClick={navLeft} style={{display:'flex',height:'1.7vw',width:'1.7vw',justifyContent:'center',alignItems:'center', backgroundColor:Colors.blue, borderRadius:5}}>
                <img alt='leftCarrot' style={{display:'flex',height:'0.7vw',justifyContent:'center',marginRight:'0.1vw'}} src={u370} />
            </div>
            <span style={{...Fonts.text,color:Colors.dark_grey,width:'8vw', textAlign:'center'}}>Page <span style={{color:Colors.black,fontWeight:550}}>{index}</span> of <span style={{color:Colors.black,fontWeight:550}}>{length}</span></span>
            <div onClick={navRight} style={{display:'flex',height:'1.7vw',width:'1.7vw',justifyContent:'center',alignItems:'center', backgroundColor:Colors.blue, borderRadius:5}}>
                <img alt='rightCarrot' style={{display:'flex',height:'0.7vw',justifyContent:'center',marginLeft:'0.1vw'}} src={u373} />
            </div>
        </div>
    }
}